import { ShieldCheck, Pencil, Eye } from "lucide-react";
import { AppColorVariant } from "../theme/AppColorVariant";
import { SelectOption } from "./SelectOption";

export enum UserRole {
  Admin = "admin",
  Editor = "editor",
  Viewer = "viewer",
}

export const UserRoleLabels: Record<UserRole, string> = {
  [UserRole.Admin]: "Admin",
  [UserRole.Editor]: "Editor",
  [UserRole.Viewer]: "Viewer",
};

export const UserRoleColors: Record<UserRole, AppColorVariant> = {
  [UserRole.Admin]: "warning",
  [UserRole.Editor]: "primary",
  [UserRole.Viewer]: "success",
};

export const UserRoleIcons: Record<UserRole, React.ElementType> = {
  [UserRole.Admin]: ShieldCheck,
  [UserRole.Editor]: Pencil,
  [UserRole.Viewer]: Eye,
};

export const UserRoleSelectOptions: SelectOption<UserRole>[] = [
  { id: UserRole.Admin, label: UserRoleLabels[UserRole.Admin], color: UserRoleColors[UserRole.Admin] },
  { id: UserRole.Editor, label: UserRoleLabels[UserRole.Editor], color: UserRoleColors[UserRole.Editor] },
  { id: UserRole.Viewer, label: UserRoleLabels[UserRole.Viewer], color: UserRoleColors[UserRole.Viewer] },
];

export interface User {
  id: string;
  role: UserRole;
  username: string;
  email: string | null;
  managedOrganizations: string[];
  password: string;
  isDeactivated: boolean;
  [key: string]: any;
}
